import Big from 'big.js';

const FinantialAccount = class {
    constructor(object) {
        if (object === undefined) {
            this.id = null
            this.name = null
            this.moneyType = null
            this.accountNumber = null
            this.accountType = null
            this.bank = null
            this.acquirer = null
            this.balance = new Big(0)
        } else {
            this.id = object.id
            this.name = object.name
            this.moneyType = object.moneyType
            this.accountNumber = object.accountNumber || null
            this.accountType = object.accountType || null
            this.bank = object.bank || null
            // Pasarela de la cuenta CARD: {code, name} o null ("no declarada").
            this.acquirer = object.acquirer || null
            this.balance = (object.balance !== undefined) ? new Big(object.balance) : new Big(0);
        }
    }
}

export default FinantialAccount
